const ADMIN_SESSION_KEY = 'difan-admin-session-v1'
const ADMIN_AUDIT_KEY = 'difan-admin-session-audit-v1'

// 실제 인증 연결 시 서버 세션의 최대 유효시간을 60분으로 적용합니다.
// 현재 Mock에서는 정책값만 유지하고 시간 만료를 강제하지 않습니다.
export const ADMIN_SESSION_POLICY = {
  plannedMaxAgeMinutes: 60,
  enforceMaxAge: false,
}

function appendSessionAudit(action, email, summary) {
  try {
    const current = JSON.parse(localStorage.getItem(ADMIN_AUDIT_KEY) || '[]')
    const rows = Array.isArray(current) ? current : []
    rows.unshift({
      id: `session-audit-${Date.now()}`,
      at: new Date().toISOString(),
      admin: email || '관리자',
      action,
      target: 'ADMIN_SESSION',
      summary,
      // 실제 IP는 브라우저에서 임의 생성하지 않고 API/프록시 계층에서 기록합니다.
      ip: 'API 연결 시 서버 기록',
    })
    localStorage.setItem(ADMIN_AUDIT_KEY, JSON.stringify(rows.slice(0, 100)))
  } catch {}
}

export function readAdminSessionAudit() {
  try {
    const rows = JSON.parse(localStorage.getItem(ADMIN_AUDIT_KEY) || '[]')
    return Array.isArray(rows) ? rows : []
  } catch {
    return []
  }
}

export function startAdminSession(email = '') {
  const session = { authenticated: true, email, signedInAt: new Date().toISOString() }
  localStorage.setItem(ADMIN_SESSION_KEY, JSON.stringify(session))
  appendSessionAudit('ADMIN_LOGIN', email, '관리자 로그인')
  return session
}

export function endAdminSession(reason = 'MANUAL') {
  let email = ''
  try { email = JSON.parse(localStorage.getItem(ADMIN_SESSION_KEY) || 'null')?.email || '' } catch {}
  localStorage.removeItem(ADMIN_SESSION_KEY)
  if (reason === 'EXPIRED') appendSessionAudit('ADMIN_SESSION_EXPIRED', email, '관리자 세션 만료로 자동 로그아웃')
  else appendSessionAudit('ADMIN_LOGOUT', email, '관리자 직접 로그아웃')
}

export function hasAdminSession() {
  try {
    const session = JSON.parse(localStorage.getItem(ADMIN_SESSION_KEY) || 'null')
    if (!session?.authenticated) return false
    if (ADMIN_SESSION_POLICY.enforceMaxAge && session.signedInAt) {
      const maxAgeMs = ADMIN_SESSION_POLICY.plannedMaxAgeMinutes * 60 * 1000
      if (Date.now() - new Date(session.signedInAt).getTime() >= maxAgeMs) {
        endAdminSession('EXPIRED')
        return false
      }
    }
    return true
  } catch {
    return false
  }
}
